export default __webpack_public_path__ + "static/media/VegetableFriedRicewithRedChiliChicken.6956151b.png";